import { IUserProps } from '@/entities/Legacy/User'

export interface ILegacyState {
  accessToken: string | null
  tokenType: string | null
  expired: number | null
  user: IUserProps | null
}

export const state = (props?: Partial<ILegacyState>): ILegacyState => ({
  accessToken: null,
  tokenType: null,
  expired: null,
  user: null,
  ...props
})

export default state
